module.exports = __webpack_public_path__ + "static/media/heroLionheart.81c86d09.webp";